import { useEffect } from 'react';

/**
 * Get the appropriate GTM container ID based on environment.
 * Uses Vite env vars: VITE_GTM_ID_DEV (development), VITE_GTM_ID_PROD (production)
 */
export function getGtmId(): string | undefined {
  if (import.meta.env.DEV) {
    return import.meta.env.VITE_GTM_ID_DEV;
  }
  return import.meta.env.VITE_GTM_ID_PROD;
}

/**
 * Google Tag Manager Script Loader
 * Injects GTM script into the document head when the component mounts.
 * Renders nothing - script is injected imperatively.
 */
export function GoogleTagManager() {
  useEffect(() => {
    const gtmId = getGtmId();
    if (!gtmId) return;

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];

    const script = document.createElement('script');
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${gtmId}');
    `;
    script.async = true;
    document.head.appendChild(script);

  }, []);

  const gtmId = getGtmId();
  if (!gtmId) return null;

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
        title="Google Tag Manager"
      />
    </noscript>
  );
}
